import type { PostFetchFnType } from "../../../common-deprecated/utils/registryTypes";
import type { FinanceOptionType } from "../../../common-deprecated/types/CommonTypes";
import { enableUscMonthlyRate } from "../utils/settings";
import type { UscStateType, UscStoreType } from "../redux/store";
import { setFinanceOption } from "../redux/actions/UscBasketActions";
import { EnvironmentEnum } from "../../../common-deprecated/utils";
import { overrideUscSettings, setShowSimilarCars } from "../redux/actions/UscSettingsActions";
import type { UscParamType } from "../utils/types";
import Debug from "../../../common-deprecated/Debug";
import { isUscRetailerLandingPdp } from "../utils/pdpUtils";
import type { UscSettingsType } from "../redux/reducers/UscSettingsReducer";

const uscPostFetch: PostFetchFnType<UscStoreType> = (store) => {
    const { dispatch, getState } = store;
    const { commonSettings, uscSettings, vehicle, save } = getState();
    const { result, type } = vehicle;
    const body = commonSettings.body as { reduxState: Partial<UscStateType> } & UscParamType;

    if (!result) return { addCacheHeaders: false };

    // Override uscSettings in the reducer if found
    const uscSettingsFromBody = body.reduxState?.uscSettings;
    if (uscSettingsFromBody) {
        const updates: Partial<UscSettingsType> = {};

        const { landingPageUrl, detailPageUrl, onRetailerSite } = uscSettingsFromBody;

        if (landingPageUrl) updates.landingPageUrl = landingPageUrl;
        if (detailPageUrl) updates.detailPageUrl = detailPageUrl;
        if (onRetailerSite) updates.onRetailerSite = onRetailerSite;

        Debug.info(`[uscPostFetch] Overriding uscSettings with values from body: ${JSON.stringify(updates)}`);

        dispatch(overrideUscSettings(updates));
    }

    if (enableUscMonthlyRate(commonSettings, uscSettings, result, type)) {
        // Set the finance option in state. Use a fallback system to determine which finance option should be set.
        let actualFinanceOption: FinanceOptionType;
        if (commonSettings.query.financeOption && ["cash", "monthly"].includes(commonSettings.query.financeOption)) {
            actualFinanceOption = commonSettings.query.financeOption;
        } else if (save.data?.financeOption) {
            actualFinanceOption = save.data.financeOption;
        } else {
            actualFinanceOption = uscSettings.defaultFinanceOption;
        }

        dispatch(setFinanceOption(actualFinanceOption, true));
    } else {
        // No financing available => always set cash
        dispatch(setFinanceOption("cash", true));
    }

    // We don't check on standalone/development environments as their respective URLs
    // will never match the URL in pageUrls.
    if (
        commonSettings.environment !== EnvironmentEnum.Development &&
        !commonSettings.isStandalone &&
        isUscRetailerLandingPdp(uscSettings)
    ) {
        dispatch(setShowSimilarCars(false));
    }

    return { addCacheHeaders: true };
};

export default uscPostFetch;
